module.exports = __webpack_public_path__ + "static/investors-info10-5b4b81236284d2b116440cc005065010.jpg";